import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight, FolderGit2 } from 'lucide-react';

const ProjectsSection = () => {
  const projects = [
    {
      title: "Next-Gen Fintech Cloud",
      category: "Infrastructure & Security",
      desc: "Migrated a legacy bank core framework over to microservice architectures protected via edge functions."
    },
    {
      title: "Global CDN Optimization",
      category: "Network Engineering",
      desc: "Reconfigured global asset distribution protocols down to custom fast cached nodes, decreasing total global page speeds."
    },
    {
      title: "SaaS Enterprise Core",
      category: "Web Development",
      desc: "Built an absolute real-time tracking interface handling continuous data ingestion from live IoT arrays."
    }
  ];

  const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.15 } }
  };

  const projectVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } }
  };

  return (
    <section className="py-24 px-6 max-w-7xl mx-auto border-t border-white/5">
      
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-6">
        <div>
          <span className="text-electric-green font-bold text-sm uppercase tracking-widest mb-2 block">
            Proven Case Studies
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
            Our Selected Works
          </h2>
        </div>
        <p className="text-gray-400 max-w-md text-sm md:text-base leading-relaxed">
          Explore the systems we have deployed for ambitious companies looking to overhaul their digital ecosystems.
        </p>
      </div>

      {/* Grid Display */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
      >
        {projects.map((project, index) => (
          <motion.div key={index} variants={projectVariants}>
            {/* CHANGED THIS DIV TO A LINK COMPONENT */}
            <Link 
              to="/contact" 
              className="group bg-[#1A1F29]/30 backdrop-blur-md border border-white/5 rounded-2xl p-8 flex flex-col h-full hover:bg-[#1A1F29]/70 hover:border-white/10 transition-all duration-300 relative overflow-hidden cursor-pointer block"
            >
              
              {/* Corner Glow Overlay */}
              <div className="absolute -bottom-10 -right-10 w-24 h-24 bg-electric-green/0 group-hover:bg-electric-green/10 rounded-full blur-xl transition-all duration-500" />
              
              {/* Card Meta Row */}
              <div className="flex items-center justify-between mb-8">
                <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center border border-white/10 text-gray-400 group-hover:border-electric-green/30 group-hover:text-electric-green transition-all">
                  <FolderGit2 className="w-4 h-4" />
                </div>
                <span className="text-xs font-semibold uppercase tracking-wider text-electric-green/80 bg-electric-green/5 px-2.5 py-1 rounded border border-electric-green/10">
                  {project.category}
                </span>
              </div>

              {/* Title & Desc */}
              <div className="flex-grow">
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-electric-green transition-colors duration-300 tracking-tight">
                  {project.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {project.desc}
                </p>
              </div>

              {/* Decorative Callout Line */}
              <div className="pt-8 mt-6 border-t border-white/5 flex items-center justify-between text-xs font-mono font-medium text-gray-500 group-hover:text-white transition-colors duration-300">
                <span>CONTACT US FOR MORE INFO</span>
                <div className="w-7 h-7 rounded-full border border-white/10 flex items-center justify-center group-hover:border-electric-green group-hover:bg-electric-green group-hover:text-royal-navy transition-all duration-300">
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </div>
              </div>

            </Link>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default ProjectsSection;